import API_URLS from '../constants/api-urls';
import axios from '../utils/axios';
import serializeQueryParams from '../utils/url/serialize-query-params';

const utmTrackerService = {
    save: (params = {}) => axios.post(API_URLS.UTM_TRACKER, params)
};

const utmTracker = {
    track: () => {
        const qp = serializeQueryParams();
        const utmKeys = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign'];
        let utmData = {};
        let trackData;

        Object.keys(qp).forEach((key) => {
            if (utmKeys.indexOf(key) > -1) {
                utmData[key.replace('utm_', '')] = qp[key];
                trackData = true;
            }
        });

        if (trackData) {
            utmData = { campaign: '', content: '', medium: '', source: '', term: '', ...utmData };

            utmTrackerService.save({ utmTrackerData: utmData });
        }
    }
};

export default utmTracker;
